import request from '@/utils/http';
const apiCrmHost = 'api-lcrm';

// 查询组织树形结构-pz
export const getOrganizationTree = (params) => {
    return request({
        url: apiCrmHost + '/lcrm/org/info/selectOrgTree',
        method: 'get',
        params
    });
};
// 新建组织-pz
export const addOrganization = (data) => {
    return request({
        url: apiCrmHost + '/crmOrg/organization/add',
        method: 'post',
        data
    });
};
// 更新组织-pz
export const updateOrganization = (data) => {
    return request({
        url: apiCrmHost + '/crmOrg/organization/update',
        method: 'post',
        data
    });
};
// 删除组织-pz
export const deleteOrganization = (params) => {
    return request({
        url: apiCrmHost + '/lcrm/org/info/deleteById',
        method: 'delete',
        params
    });
};
// 查询用户列表-pz
export const getUserList = (data) => {
    return request({
        url: apiCrmHost + '/lcrm/org/user/selectByCondition',
        method: 'post',
        data
    });
};
// 更新用户-pz
export const updateUser = (data) => {
    return request({
        url: apiCrmHost + '/lcrm/org/user/update',
        method: 'post',
        data
    });
};
// 用户状态变更-pz
export const updateUserStatus = (data) => {
    return request({
        url: apiCrmHost + '/lcrm/org/user/enableChange',
        method: 'post',
        data
    });
};
// 导出用户-pz
export const exportUserList = (data) => {
    return request({
        url: apiCrmHost + '/lcrm/org/user/export',
        method: 'post',
        data
    });
};
// 查询日志列表-pz
export const getOrganizationLogList = (data) => {
    return request({
        url: apiCrmHost + '/uap/user/change/page',
        method: 'post',
        data
    });
};
// 根据ID查询UAP用户变更记录-pz
export const getOrganizationLogProcess = (params) => {
    return request({
        url: apiCrmHost + '/uap/user/change/getById',
        method: 'get',
        params
    });
};
// 保存变更-pz
export const saveOrganizationLog = (data) => {
    return request({
        url: apiCrmHost + '/uap/user/change/handle',
        method: 'post',
        data
    });
};
// 同意/忽略变更-pz
export const agreeAndIgnoreOrganizationLog = (data) => {
    return request({
        url: apiCrmHost + '/uap/user/change/batch/handle',
        method: 'post',
        data
    });
};
